<template>
  <div class="item" :class="{'active': idOpenActionBtns === dataSource.subjectId}">
    <div class="item__wrap position-rel">
      <div class="item__head aspect-ratio aspect-ratio--16-9 text-center border-rd-4 bg-transparent" @click="handleOpenActions(dataSource)">
        <div class="img__wrap" v-if="dataSource.imageUrl">
          <img :src="dataSource.imageUrl ? handleResizeImg(dataSource.imageUrl) : img404" :alt="dataSource.name">
        </div>
      </div>
      <div class="item__body">
        <h3
          class="item__title font-size-20 font-sanpro-semibold primary-color-txt display-block text-center"
          @click="handleOpenActions(dataSource)"
        >
          {{ dataSource.name }}
        </h3>
      </div>
      <div class="item__footer" :class="{'active': idOpenActionBtns === dataSource.subjectId}">
        <!-- <transition name="fade-transform-y"> -->
          <ul v-show="idOpenActionBtns === dataSource.subjectId" class="margin-0 p-0">
            <li
              v-for="(item, index) of examTypes"
              :key="index"
              class="list-style-none"
              @click="directToDetail(item, dataSource)"
            >
              {{ item.bookTypeName }}
            </li>
          </ul>
        <!-- </transition> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { APP_CONFIG } from '@/utils/constants'
import { replaceImageResize } from '@/helpers/functions'
import mixinExam from './../../_store/mixinExam'
import { STORE_KEY, TYPE_EXERCISE_OTHER, TYPE_EXERCISE_THEMATIC, TYPE_EXERCISE_EXAM } from './../../_store/constants'
const img404 = require(`@/assets/images/img_404.jpg`)

export default {
  name: 'ItemExam',
  props: {
    dataSource: Object,
    examTypes: Array,
    tabPracticeTypeId: Number
  },
  data() {
    return {
      img404,
    };
  },
  computed: {
    ...mapState(STORE_KEY, ['idOpenActionBtns']),

    routerQuery() {
      return this.$route.query;
    }
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetIdShowBtnsItemExercise']),

    handleResizeImg (link) {
      return replaceImageResize(link, {width: 285, height: 404})
    },

    directToDetail (data, subject) {
      console.log('data', data);
      if (!data) {
        return
      }
      let self = this
      let routeQuery = self.$route.query;
      let classId = parseInt(self.$route.query.lop)
      let typeId = parseInt(data.practiceTypeId)
      let subjectId = subject.subjectId

      switch (data.type) {
        case TYPE_EXERCISE_OTHER:
          self.$router.push({name: 'exerciseOtherDetail', params: {classId, subjectId, typeId, id: 0 }, query: {cauhoi: 1} })
          break;
        case TYPE_EXERCISE_THEMATIC:
          self.$router.push({name: 'exerciseThematicDetail', params: {classId, subjectId, typeId, id: 0 }, query: {cauhoi: 0}})
          break;
        case TYPE_EXERCISE_EXAM:
          self.$router.push({ name: 'exerciseExamList', params: {classId, subjectId} })
          break;
        default:
          console.log('typeId', typeId)
          self.$router.push({name: "exerciseDetail", params:{classId, subjectId, bookType: data.bookTypeId , practiceType: typeId}})
          break;
      }
    },

    handleOpenActions (data) {
      this.acSetIdShowBtnsItemExercise(this.idOpenActionBtns === data.subjectId ? 0 : data.subjectId)
    }
  }
};
</script>

<style lang="scss" scoped>
  .item {
    margin-bottom: 35px;

    &__wrap {
      padding: 8px;
      @extend .border-rd-10;
    }

    &__footer {
      // position: absolute;
      // top: 100%;
      // left: 0;
      // width: 100%;
      overflow:hidden;
      transition: max-height 0.5s ease-out; // note that we're transitioning max-height, not height!
      height: auto;
      max-height: 0;
      border-radius: 0 0 4px 4px;
      z-index: 2;

      &.active {
        max-height: 600px; // still have to hard-code a value!
      }

      ul {
        li {
          @extend .display-block;
          @extend .bg-color-light;
          @extend .primary-color;
          @extend .font-sanpro-semibold;
          @extend .font-size-15;
          @extend .text-center;
          @extend .border-rd-4;
          padding: 5px 8px;

          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }
      }
    }

    &__body {
      padding: 8px 0 10px;
    }

    &.active {
      .item {
        &__wrap {
          @extend .color_bg_gray_light;
          border-radius: 4px 4px 0 0;
        }

        &__footer {
          padding: 0 8px 10px;
          @extend .color_bg_gray_light;
        }
      }
    }

    @media screen and ( min-width: 992px ) and ( max-width: 1300px ) {
      &__title {
        font-size: 18px;
      }
    }
  }
</style>
